var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import styled, { css } from 'styled-components';
import MuiButton from '@material-ui/core/Button';
var borderRadius = function borderRadius(edge, theme) {
  var edges = {
    default: theme.shape.borderRadius,
    rounded: 99,
    sharp: 0
  };
  return edges[edge];
};
var spacing = function spacing(size, theme) {
  var sizes = {
    large: theme.spacing(2.2, 10),
    medium: theme.spacing(1.7, 8),
    small: theme.spacing(1, 4)
  };
  return sizes[size];
};
export var colorMap = function colorMap(color) {
  var colors = {
    primaryAlt: 'inherit',
    secondaryAlt: 'inherit',
    tertiary: 'inherit',
    error: 'inherit'
  };
  if (colors[color]) {
    return colors[color];
  }
  return color;
};
export var StyledButton = styled(MuiButton)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var edges = _ref.edges,
    origcolor = _ref.origcolor,
    size = _ref.size,
    variant = _ref.variant,
    theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    && {\n      letter-spacing: 0.5px;\n      padding: ", ";\n      border-radius: ", "px;\n    }\n\n    &&.Mui-disabled:not(.MuiLoadingButton-pending) {\n      box-shadow: none;\n      background: rgba(0, 0, 0, 0.12);\n      border: 1px solid transparent;\n      color: rgba(0, 0, 0, 0.26);\n    }\n\n    &&:not(.Mui-disabled),\n    &&.MuiLoadingButton-pending {\n      color: ", ";\n\n      ", "\n    }\n\n    .MuiButton-iconSizeMedium svg,\n    .MuiButton-iconSizeLarge svg {\n      font-size: 30px;\n      margin: -5px 0;\n    }\n\n    .MuiTouchRipple-root {\n      display: none !important;\n    }\n  "])), variant === 'text' ? 0 : spacing(size, theme), borderRadius(edges, theme), variant === 'contained' ? theme.palette[origcolor].contrastText : theme.palette[origcolor].main, variant === 'contained' && theme.palette[origcolor] && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        background-color: ", ";\n        border: 1px solid transparent;\n        &:hover {\n          background-color: ", ";\n        }\n      "])), theme.palette[origcolor].main, theme.palette[origcolor].dark));
});